import { Service } from "@zapier/canvas-state";
import { ServiceIcon } from "@zapier/design-system";
import useServiceById from "../../hooks/useServiceById";
import cleanUpAppId from "../../utils/cleanUpAppId";
import getAppIconUrl from "../../utils/getAppIconUrl";

type AppIconProps = {
  app: Service;
  hasBorder?: boolean;
};

export const AppIcon = ({ app, hasBorder = true }: AppIconProps) => {
  const getService = useServiceById();

  const appId = app.currentImplementation.id;
  const service = getService(appId);
  const serviceName = service?.name ?? cleanUpAppId(appId);
  const images = service?.images;
  const src = getAppIconUrl(appId, images, 30);

  return (
    <ServiceIcon
      alt={`${serviceName} icon`}
      hasBorder={hasBorder}
      size="small"
      hasShadow={false}
      serviceName={serviceName}
      src={src}
    />
  );
};
